import { Box, Grid, Typography } from "@mui/material"
import "./Administration.css"
import PersonIcon from "@mui/icons-material/Person"
import AdministrationCard from "./AdministrationCard"
import CorporateFareIcon from "@mui/icons-material/CorporateFare"
import DescriptionIcon from "@mui/icons-material/Description"
import ScheduleIcon from "@mui/icons-material/Schedule"
import ApprovalIcon from "@mui/icons-material/Approval"
import CategoryIcon from "@mui/icons-material/Category"
import SettingsIcon from "@mui/icons-material/Settings"
import NotificationsIcon from "@mui/icons-material/Notifications"
import { Link } from "react-router"
import React from "react"

function Administration() {
  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Administration
      </Typography>
      <Grid container={true} spacing={3} className={"admin-grid-container"}>
        <Grid item={true} xs={3}>
          <Link to={"/Administration/Organisations"}>
            <AdministrationCard
              icon={
                <CorporateFareIcon className={"admin-grid-item-paper-icon"}></CorporateFareIcon>
              }
              name={"ORGANISATIONS"}
              description={"Manage organisations"}
            />
          </Link>
        </Grid>
        <Grid item={true} xs={3}>
          <Link to={"/Administration/Users"}>
            <AdministrationCard
              icon={<PersonIcon className={"admin-grid-item-paper-icon"}></PersonIcon>}
              name={"USERS"}
              description={"Manage users"}
            />
          </Link>
        </Grid>
        <Grid item={true} xs={3}>
          <Link to={"/Administration/Contracts"}>
            <AdministrationCard
              icon={<DescriptionIcon className={"admin-grid-item-paper-icon"}></DescriptionIcon>}
              name={"CONTRACTS"}
              description={"Manage contracts"}
            />
          </Link>
        </Grid>
        <Grid item={true} xs={3}>
          <Link to={"/Administration/Products"}>
            <AdministrationCard
              icon={<CategoryIcon className={"admin-grid-item-paper-icon"}></CategoryIcon>}
              name={"PRODUCTS"}
              description={"Manage products"}
            />
          </Link>
        </Grid>
        <Grid item={true} xs={3}>
          <Link to={"/Administration/Publish-Approvals"}>
            <AdministrationCard
              icon={<ApprovalIcon className="admin-grid-item-paper-icon" />}
              name="PUBLISH APPROVALS"
              description="Base Graph Publishing Audit"
            />
          </Link>
        </Grid>
        <Grid item={true} xs={3}>
          <AdministrationCard
            disabled
            icon={<ScheduleIcon className={"admin-grid-item-paper-icon"}></ScheduleIcon>}
            name={"SCHEDULING"}
            description={"Manage scheduling"}
          />
        </Grid>
        <Grid item={true} xs={3}>
          <AdministrationCard
            disabled
            icon={<SettingsIcon className={"admin-grid-item-paper-icon"}></SettingsIcon>}
            name={"STFP Delivery Configuration"}
            description={"Manage configurations"}
          />
        </Grid>
        <Grid item={true} xs={3}>
          <AdministrationCard
            disabled
            icon={<NotificationsIcon className={"admin-grid-item-paper-icon"}></NotificationsIcon>}
            name={"Expiring Contract Notifications"}
            description={"Manage notifications"}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default Administration
